export function showOnlyFirstSixDigits(string) {
  return string.slice(0, 6);
}
